/**
 * Ohio ZIP Code to County Mapping
 * Used for auto-detecting county from ZIP code
 */

// Ohio ZIP Code to County Mapping (Primary county for each ZIP)
export const OHIO_ZIP_TO_COUNTY = {
  // Franklin County (Columbus area) - 432xx
  '43201': 'Franklin', '43202': 'Franklin', '43203': 'Franklin', '43204': 'Franklin', '43205': 'Franklin',
  '43206': 'Franklin', '43207': 'Franklin', '43209': 'Franklin', '43210': 'Franklin', '43211': 'Franklin',
  '43212': 'Franklin', '43213': 'Franklin', '43214': 'Franklin', '43215': 'Franklin', '43216': 'Franklin',
  '43217': 'Franklin', '43218': 'Franklin', '43219': 'Franklin', '43220': 'Franklin', '43221': 'Franklin',
  '43222': 'Franklin', '43223': 'Franklin', '43224': 'Franklin', '43226': 'Franklin', '43227': 'Franklin',
  '43228': 'Franklin', '43229': 'Franklin', '43230': 'Franklin', '43231': 'Franklin', '43232': 'Franklin',
  '43234': 'Franklin', '43235': 'Franklin', '43236': 'Franklin', '43240': 'Franklin', '43251': 'Franklin',
  '43260': 'Franklin', '43265': 'Franklin', '43266': 'Franklin', '43268': 'Franklin', '43270': 'Franklin',
  '43271': 'Franklin', '43272': 'Franklin', '43279': 'Franklin', '43287': 'Franklin', '43291': 'Franklin',

  // Cuyahoga County (Cleveland area) - 441xx
  '44101': 'Cuyahoga', '44102': 'Cuyahoga', '44103': 'Cuyahoga', '44104': 'Cuyahoga', '44105': 'Cuyahoga',
  '44106': 'Cuyahoga', '44107': 'Cuyahoga', '44108': 'Cuyahoga', '44109': 'Cuyahoga', '44110': 'Cuyahoga',
  '44111': 'Cuyahoga', '44112': 'Cuyahoga', '44113': 'Cuyahoga', '44114': 'Cuyahoga', '44115': 'Cuyahoga',
  '44116': 'Cuyahoga', '44117': 'Cuyahoga', '44118': 'Cuyahoga', '44119': 'Cuyahoga', '44120': 'Cuyahoga',
  '44121': 'Cuyahoga', '44122': 'Cuyahoga', '44123': 'Cuyahoga', '44124': 'Cuyahoga', '44125': 'Cuyahoga',
  '44126': 'Cuyahoga', '44127': 'Cuyahoga', '44128': 'Cuyahoga', '44129': 'Cuyahoga', '44130': 'Cuyahoga',
  '44131': 'Cuyahoga', '44132': 'Cuyahoga', '44133': 'Cuyahoga', '44134': 'Cuyahoga', '44135': 'Cuyahoga',
  '44136': 'Cuyahoga', '44137': 'Cuyahoga', '44138': 'Cuyahoga', '44139': 'Cuyahoga', '44140': 'Cuyahoga',
  '44141': 'Cuyahoga', '44142': 'Cuyahoga', '44143': 'Cuyahoga', '44144': 'Cuyahoga', '44145': 'Cuyahoga',
  '44146': 'Cuyahoga', '44147': 'Cuyahoga', '44149': 'Cuyahoga',

  // Hamilton County (Cincinnati area) - 452xx
  '45201': 'Hamilton', '45202': 'Hamilton', '45203': 'Hamilton', '45204': 'Hamilton', '45205': 'Hamilton',
  '45206': 'Hamilton', '45207': 'Hamilton', '45208': 'Hamilton', '45209': 'Hamilton', '45210': 'Hamilton',
  '45211': 'Hamilton', '45212': 'Hamilton', '45213': 'Hamilton', '45214': 'Hamilton', '45215': 'Hamilton',
  '45216': 'Hamilton', '45217': 'Hamilton', '45218': 'Hamilton', '45219': 'Hamilton', '45220': 'Hamilton',
  '45221': 'Hamilton', '45222': 'Hamilton', '45223': 'Hamilton', '45224': 'Hamilton', '45225': 'Hamilton',
  '45226': 'Hamilton', '45227': 'Hamilton', '45229': 'Hamilton', '45230': 'Hamilton', '45231': 'Hamilton',
  '45232': 'Hamilton', '45233': 'Hamilton', '45234': 'Hamilton', '45235': 'Hamilton', '45236': 'Hamilton',
  '45237': 'Hamilton', '45238': 'Hamilton', '45239': 'Hamilton', '45240': 'Hamilton', '45241': 'Hamilton',
  '45242': 'Hamilton', '45243': 'Hamilton', '45244': 'Hamilton', '45245': 'Hamilton', '45246': 'Hamilton',
  '45247': 'Hamilton', '45248': 'Hamilton', '45249': 'Hamilton', '45250': 'Hamilton', '45251': 'Hamilton',
  '45252': 'Hamilton', '45253': 'Hamilton', '45254': 'Hamilton', '45255': 'Hamilton',

  // Summit County (Akron area) - 442xx, 443xx
  '44301': 'Summit', '44302': 'Summit', '44303': 'Summit', '44304': 'Summit', '44305': 'Summit',
  '44306': 'Summit', '44307': 'Summit', '44308': 'Summit', '44309': 'Summit', '44310': 'Summit',
  '44311': 'Summit', '44312': 'Summit', '44313': 'Summit', '44314': 'Summit', '44315': 'Summit',
  '44316': 'Summit', '44317': 'Summit', '44319': 'Summit', '44320': 'Summit', '44321': 'Summit',
  '44333': 'Summit', '44334': 'Summit',

  // Montgomery County (Dayton area) - 454xx
  '45401': 'Montgomery', '45402': 'Montgomery', '45403': 'Montgomery', '45404': 'Montgomery', '45405': 'Montgomery',
  '45406': 'Montgomery', '45409': 'Montgomery', '45410': 'Montgomery', '45412': 'Montgomery', '45413': 'Montgomery',
  '45414': 'Montgomery', '45415': 'Montgomery', '45416': 'Montgomery', '45417': 'Montgomery', '45419': 'Montgomery',
  '45420': 'Montgomery', '45422': 'Montgomery', '45423': 'Montgomery', '45424': 'Montgomery', '45426': 'Montgomery',
  '45428': 'Montgomery', '45429': 'Montgomery', '45430': 'Montgomery', '45431': 'Montgomery', '45432': 'Montgomery',
  '45433': 'Montgomery', '45434': 'Montgomery', '45435': 'Montgomery', '45439': 'Montgomery', '45440': 'Montgomery',
  '45441': 'Montgomery', '45448': 'Montgomery', '45449': 'Montgomery', '45458': 'Montgomery', '45459': 'Montgomery',
  '45469': 'Montgomery', '45470': 'Montgomery', '45475': 'Montgomery', '45479': 'Montgomery', '45481': 'Montgomery',
  '45482': 'Montgomery', '45490': 'Montgomery',

  // Lucas County (Toledo area) - 436xx
  '43601': 'Lucas', '43603': 'Lucas', '43604': 'Lucas', '43605': 'Lucas', '43606': 'Lucas',
  '43607': 'Lucas', '43608': 'Lucas', '43609': 'Lucas', '43610': 'Lucas', '43611': 'Lucas',
  '43612': 'Lucas', '43613': 'Lucas', '43614': 'Lucas', '43615': 'Lucas', '43616': 'Lucas',
  '43617': 'Lucas', '43618': 'Lucas', '43619': 'Lucas', '43620': 'Lucas', '43623': 'Lucas',
  '43635': 'Lucas', '43652': 'Lucas', '43654': 'Lucas', '43656': 'Lucas', '43657': 'Lucas',
  '43659': 'Lucas', '43660': 'Lucas', '43661': 'Lucas', '43666': 'Lucas', '43667': 'Lucas',
  '43681': 'Lucas', '43682': 'Lucas', '43697': 'Lucas', '43699': 'Lucas',

  // Mahoning County (Youngstown area) - 445xx
  '44501': 'Mahoning', '44502': 'Mahoning', '44503': 'Mahoning', '44504': 'Mahoning', '44505': 'Mahoning',
  '44506': 'Mahoning', '44507': 'Mahoning', '44509': 'Mahoning', '44510': 'Mahoning', '44511': 'Mahoning',
  '44512': 'Mahoning', '44513': 'Mahoning', '44514': 'Mahoning', '44515': 'Mahoning', '44555': 'Mahoning',

  // Stark County (Canton area) - 447xx
  '44701': 'Stark', '44702': 'Stark', '44703': 'Stark', '44704': 'Stark', '44705': 'Stark',
  '44706': 'Stark', '44707': 'Stark', '44708': 'Stark', '44709': 'Stark', '44710': 'Stark',
  '44711': 'Stark', '44714': 'Stark', '44718': 'Stark', '44720': 'Stark', '44721': 'Stark',
  '44730': 'Stark', '44735': 'Stark', '44750': 'Stark', '44767': 'Stark', '44799': 'Stark',

  // Lorain County (Lorain/Elyria) - 440xx
  '44001': 'Lorain', '44003': 'Ashtabula', '44004': 'Ashtabula', '44010': 'Ashtabula', '44011': 'Lorain',
  '44012': 'Lorain', '44017': 'Cuyahoga', '44021': 'Geauga', '44022': 'Cuyahoga', '44023': 'Geauga',
  '44024': 'Geauga', '44026': 'Geauga', '44028': 'Lorain', '44030': 'Ashtabula', '44032': 'Ashtabula',
  '44033': 'Geauga', '44035': 'Lorain', '44036': 'Ashtabula', '44039': 'Lorain', '44040': 'Cuyahoga',
  '44041': 'Ashtabula', '44044': 'Lorain', '44045': 'Lake', '44046': 'Geauga', '44047': 'Ashtabula',
  '44048': 'Ashtabula', '44049': 'Lorain', '44050': 'Lorain', '44052': 'Lorain', '44053': 'Lorain',
  '44054': 'Lorain', '44055': 'Lorain', '44056': 'Cuyahoga', '44057': 'Lake', '44060': 'Lake',
  '44061': 'Lake', '44062': 'Geauga', '44064': 'Geauga', '44065': 'Geauga', '44067': 'Cuyahoga',
  '44068': 'Ashtabula', '44070': 'Cuyahoga', '44072': 'Geauga', '44073': 'Geauga', '44074': 'Lorain',
  '44076': 'Ashtabula', '44077': 'Lake', '44080': 'Geauga', '44081': 'Lake', '44082': 'Ashtabula',
  '44084': 'Ashtabula', '44085': 'Ashtabula', '44086': 'Lake', '44087': 'Cuyahoga', '44088': 'Ashtabula',
  '44089': 'Lorain', '44090': 'Lorain', '44092': 'Lake', '44093': 'Ashtabula', '44094': 'Lake',
  '44095': 'Lake', '44099': 'Ashtabula',

  // Butler County (Hamilton area) - 450xx
  '45001': 'Hamilton', '45002': 'Hamilton', '45003': 'Preble', '45004': 'Butler', '45005': 'Warren',
  '45011': 'Butler', '45012': 'Butler', '45013': 'Butler', '45014': 'Butler', '45015': 'Butler',
  '45018': 'Butler', '45030': 'Hamilton', '45032': 'Warren', '45033': 'Hamilton', '45034': 'Warren',
  '45036': 'Warren', '45039': 'Warren', '45040': 'Warren', '45041': 'Warren', '45042': 'Butler',
  '45044': 'Butler', '45050': 'Butler', '45051': 'Hamilton', '45052': 'Hamilton', '45053': 'Butler',
  '45054': 'Warren', '45055': 'Warren', '45056': 'Butler', '45061': 'Butler', '45062': 'Butler',
  '45063': 'Butler', '45064': 'Preble', '45065': 'Warren', '45066': 'Warren', '45067': 'Butler',
  '45068': 'Warren', '45069': 'Butler', '45070': 'Preble', '45071': 'Butler',

  // Delaware County - 430xx
  '43003': 'Delaware', '43015': 'Delaware', '43021': 'Delaware', '43032': 'Delaware', '43035': 'Delaware',
  '43061': 'Delaware', '43065': 'Delaware', '43074': 'Delaware', '43082': 'Delaware',

  // Additional key ZIP codes for major cities
  '44201': 'Portage', '44223': 'Summit', '44224': 'Summit', '44236': 'Summit', '44278': 'Summit',
  '43085': 'Franklin', '43017': 'Franklin', '43016': 'Franklin',
};

/**
 * Get county suggestion from ZIP code
 * @param {string} zipCode - The ZIP code to look up
 * @returns {string|null} - The county name or null if not found
 */
export const getCountyFromZip = (zipCode) => {
  if (!zipCode || zipCode.length < 5) return null;
  const zip = zipCode.substring(0, 5);
  return OHIO_ZIP_TO_COUNTY[zip] || null;
};
